import { FamilyDoctor } from 'types/entity';
import { Action } from '../../../types/redux';
import { SEARCH_DOCTORS, SET_SEARCHED_DOCTOR_LIST, APPEND_DOCTOR_LIST, RESET_DOCTOR_LIST } from './constants';
import { DoctorSearchStore } from 'types/store';

const initialState: Partial<DoctorSearchStore> = {
  doctors: [] as FamilyDoctor[],
  currentPage: 1,
  hasMore: false,
  loading: false,
}

// An explicit `hasMore` always wins over one derived from `total`, since deduped merges make total unreliable.
type SearchListPayload = { doctors: FamilyDoctor[], total?: number, hasMore?: boolean }

const reducer = function doctorReducer(
  state: any = initialState, action : Action<SearchListPayload>,
): Partial<DoctorSearchStore> {
  switch(action.type) {
    case SEARCH_DOCTORS: {
      return {
        ...state,
        loading: true,
      }
    }
    case SET_SEARCHED_DOCTOR_LIST: {
      const doctors = action?.payload?.doctors || []
      const total = action?.payload?.total
      const hasMore = action?.payload?.hasMore ?? (total !== undefined ? doctors.length < total : false)
      return {
        ...state,
        doctors,
        currentPage: 1,
        hasMore,
        loading: false,
      }
    }
    case APPEND_DOCTOR_LIST: {
      const newDoctors: FamilyDoctor[] = action?.payload?.doctors || []
      const doctors = [...(state.doctors || []), ...newDoctors]
      const total = action?.payload?.total
      const hasMore = action?.payload?.hasMore ?? (total !== undefined ? doctors.length < total : false)
      return {
        ...state,
        doctors,
        currentPage: (state.currentPage || 1) + 1,
        hasMore,
        loading: false,
      }
    }
    case RESET_DOCTOR_LIST: {
      return {
        ...state,
        doctors: [],
        currentPage: 1,
        hasMore: false,
        loading: false,
      }
    }
    default:
      return { ...state };
  }
}

export default reducer
